export const DomainModelMessage = {
  showMessage: async (domainModelContext, opts, messageType, body, query) => {
    if (domainModelContext === undefined) return true;

    let result = true;
    if (opts !== undefined && opts[messageType] !== undefined) {
      let message = opts[messageType](body, query);
      result = await domainModelContext.messageProvider[messageType](message);
    }
    return result;
  },
};
